var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography, Accordion, AccordionSummary, AccordionDetails, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import { colors } from "../../Themes/colors";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import RichTextEditor from "../../components/QuillEditer";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
var FAQ_FILE_MAX_SIZE_BYTES = 25 * 1024 * 1024;
var CHATBOT_FAQ_PAGE_SIZE = 10;
var FAQ_FILE_ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "application/pdf",
];
var BLOB_BASE = "https://auxcap.blob.core.windows.net/";
function getBlobBase() {
    var _a, _b, _c;
    var env = process.env.NODE_ENV === constants.ENV.PRODUCTION &&
        ((_b = (_a = process.env.API_DOMAIN) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("uat"))
        ? constants.ENV.UAT
        : ((_c = process.env.NODE_ENV) !== null && _c !== void 0 ? _c : constants.ENV.DEV);
    switch (env) {
        case constants.ENV.PRODUCTION:
            return "https://auxcapcustomerportalprod.blob.core.windows.net/";
        case constants.ENV.DEV:
        case constants.ENV.QA:
        case constants.ENV.UAT:
        default:
            return BLOB_BASE;
    }
}
function getBlobContainer() {
    var _a, _b, _c;
    var env = process.env.NODE_ENV === constants.ENV.PRODUCTION &&
        ((_b = (_a = process.env.API_DOMAIN) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("uat"))
        ? constants.ENV.UAT
        : ((_c = process.env.NODE_ENV) !== null && _c !== void 0 ? _c : constants.ENV.DEV);
    switch (env) {
        case constants.ENV.DEV:
            return "auxcap-dev-customer-portal";
        case constants.ENV.QA:
            return "auxcap-qa-customer-portal";
        case constants.ENV.UAT:
            return "auxcap-uat-customer-portal";
        case constants.ENV.PRODUCTION:
            return "auxcap-prod-customer-portal";
        default:
            return "auxcap-dev-customer-portal";
    }
}
function getImageUrl(imagePath) {
    var _a;
    var path = (_a = imagePath === null || imagePath === void 0 ? void 0 : imagePath.trim()) !== null && _a !== void 0 ? _a : "";
    if (!path)
        return "";
    if (path.startsWith("http://") || path.startsWith("https://"))
        return path;
    var normalized = path.replace(/^\//, "");
    var container = getBlobContainer();
    var containerPath = normalized.startsWith("auxcap-")
        ? "".concat(normalized.split("/")[0], "/").concat(normalized)
        : "".concat(container, "/").concat(container, "/").concat(normalized);
    return "".concat(getBlobBase()).concat(containerPath);
}
function preserveBulletPoints(html) {
    if (!html)
        return html;
    if (!html.includes("data-list=")) {
        return html;
    }
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    var olElements = tempDiv.querySelectorAll("ol");
    olElements.forEach(function (ol) {
        var _a;
        var listItems = Array.from(ol.querySelectorAll("li"));
        if (listItems.length === 0)
            return;
        var groups = [];
        var currentGroup = { type: null, items: [] };
        listItems.forEach(function (li) {
            var dataList = li.getAttribute("data-list");
            var listType = dataList === "bullet"
                ? "bullet"
                : dataList === "ordered"
                    ? "ordered"
                    : null;
            if (listType && listType === currentGroup.type) {
                currentGroup.items.push(li);
            }
            else {
                if (currentGroup.type !== null && currentGroup.items.length > 0) {
                    groups.push({
                        type: currentGroup.type,
                        items: __spreadArray([], currentGroup.items, true),
                    });
                }
                currentGroup = { type: listType, items: [li] };
            }
        });
        if (currentGroup.type !== null && currentGroup.items.length > 0) {
            groups.push({
                type: currentGroup.type,
                items: __spreadArray([], currentGroup.items, true),
            });
        }
        if (groups.length > 0) {
            var fragment_1 = document.createDocumentFragment();
            groups.forEach(function (group) {
                var listTag = group.type === "bullet" ? "ul" : "ol";
                var newList = document.createElement(listTag);
                group.items.forEach(function (li) {
                    var newLi = li.cloneNode(true);
                    newLi.removeAttribute("data-list");
                    var qlUiSpans = newLi.querySelectorAll("span.ql-ui");
                    qlUiSpans.forEach(function (span) { return span.remove(); });
                    newList.appendChild(newLi);
                });
                fragment_1.appendChild(newList);
            });
            (_a = ol.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(fragment_1, ol);
        }
    });
    return tempDiv.innerHTML;
}
var getPlainTextLength = function (html) {
    var _a;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return ((_a = tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.length) || 0;
};
var hasTextContent = function (html) {
    if (!html || !html.trim())
        return false;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    var textContent = tempDiv.textContent || tempDiv.innerText || "";
    return textContent.trim().length > 0;
};
var CustomerPortalFaqManagement = function (_a) {
    var _b = _a === void 0 ? {} : _a, portalIdProp = _b.portalId, _c = _b.embedded, embedded = _c === void 0 ? false : _c, _d = _b.heading, heading = _d === void 0 ? "Frequently Asked Questions" : _d, _e = _b.permission, permission = _e === void 0 ? "faqs" : _e;
    var _f = useState([]), faqs = _f[0], setFaqs = _f[1];
    var _g = useState(true), isLoadingFaqs = _g[0], setIsLoadingFaqs = _g[1];
    var _h = useState(false), isAddingFaq = _h[0], setIsAddingFaq = _h[1];
    var _j = useState(null), editingFaqId = _j[0], setEditingFaqId = _j[1];
    var _k = useState(""), question = _k[0], setQuestion = _k[1];
    var _l = useState(""), content = _l[0], setContent = _l[1];
    var _m = useState(null), answerUpload = _m[0], setAnswerUpload = _m[1];
    var _o = useState(""), existingAnswerImagePath = _o[0], setExistingAnswerImagePath = _o[1];
    var _p = useState(false), imageRemovedInEdit = _p[0], setImageRemovedInEdit = _p[1];
    var _q = useState(false), deleteConfirmationOpen = _q[0], setDeleteConfirmationOpen = _q[1];
    var _r = useState(null), pendingDeleteFaqId = _r[0], setPendingDeleteFaqId = _r[1];
    var _s = useState(portalIdProp !== null && portalIdProp !== void 0 ? portalIdProp : null), portalId = _s[0], setPortalId = _s[1];
    var _t = useState(1), chatbotPage = _t[0], setChatbotPage = _t[1];
    var _u = useState(1), chatbotTotalPages = _u[0], setChatbotTotalPages = _u[1];
    var _v = useState(0), chatbotTotalCount = _v[0], setChatbotTotalCount = _v[1];
    var cpPermissions = useCustomerPortalPermissions();
    var faqPerms = cpPermissions[permission];
    var isChatbotFaqs = permission === "chatbotFaqs";
    var resolveDefaultPortalId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, portals, getPortalId, getPortalName_1, targetPortal, targetPortalId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: false,
                        })];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        portals = response.data.data || [];
                        getPortalId = function (p) { var _a; return (_a = p.id) !== null && _a !== void 0 ? _a : p.Id; };
                        getPortalName_1 = function (p) {
                            return p.title || p.PortalName || p.BrandName || p.Name || "";
                        };
                        targetPortal = portals.find(function (p) { return getPortalName_1(p).toLowerCase() === "avant"; });
                        if (!targetPortal && portals.length > 0) {
                            targetPortal = portals[0];
                        }
                        targetPortalId = targetPortal ? getPortalId(targetPortal) : null;
                        if (targetPortalId) {
                            setPortalId(Number(targetPortalId));
                        }
                    }
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error resolving default portal:", error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var fetchAllFaqs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, portals, getPortalId, getPortalName_2, targetPortal, targetPortalId, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    setIsLoadingFaqs(true);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: false,
                        })];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 3];
                    portals = response.data.data || [];
                    getPortalId = function (p) { var _a; return (_a = p.id) !== null && _a !== void 0 ? _a : p.Id; };
                    getPortalName_2 = function (p) {
                        return p.title || p.PortalName || p.BrandName || p.Name || "";
                    };
                    targetPortal = portals.find(function (p) { return getPortalName_2(p).toLowerCase() === "avant"; });
                    if (!targetPortal && portals.length > 0) {
                        targetPortal = portals[0];
                    }
                    targetPortalId = targetPortal ? getPortalId(targetPortal) : null;
                    if (!targetPortalId) return [3, 3];
                    setPortalId(Number(targetPortalId));
                    return [4, fetchFaqsForPortal(Number(targetPortalId))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3, 6];
                case 4:
                    error_2 = _a.sent();
                    console.error("Error fetching portals:", error_2);
                    utility.alert("Failed to load FAQs", constants.TOAST_TYPES.ERROR);
                    return [3, 6];
                case 5:
                    setIsLoadingFaqs(false);
                    return [7];
                case 6: return [2];
            }
        });
    }); };
    var fetchFaqsForPortal = function (pId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, transformedFaqs, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!pId)
                        return [2];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_LIST,
                            payLoad: {
                                portalId: Number(pId),
                            },
                            showLoader: false,
                        })];
                case 2:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        transformedFaqs = (apiResponse.data || []).map(function (faq) { return ({
                            id: Number(faq.Id),
                            question: faq.Question || "",
                            answer: preserveBulletPoints(faq.Answer || ""),
                            answerUpload: faq.ImageUrl || "",
                        }); });
                        setFaqs(transformedFaqs);
                    }
                    else {
                        console.warn("Failed to fetch FAQs:", (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message);
                        setFaqs([]);
                    }
                    return [3, 4];
                case 3:
                    error_3 = _b.sent();
                    console.error("Error fetching FAQs:", error_3);
                    setFaqs([]);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var fetchChatbotFaqs = function (page) {
        if (page === void 0) { page = chatbotPage; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, apiResponse, transformedFaqs, pagination, totalCount, totalPages, estimatedTotalPages, error_4;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        _l.trys.push([0, 2, , 3]);
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_CHATBOT_FAQ_LIST,
                                payLoad: {
                                    page: page,
                                    limit: CHATBOT_FAQ_PAGE_SIZE,
                                },
                                showLoader: false,
                            })];
                    case 1:
                        response = _l.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            apiResponse = response.data;
                            transformedFaqs = (apiResponse.data || []).map(function (faq) {
                                var _a;
                                return ({
                                    id: Number((_a = faq.Id) !== null && _a !== void 0 ? _a : faq.id),
                                    question: faq.Question || faq.question || "",
                                    answer: preserveBulletPoints(faq.Answer || faq.answer || ""),
                                    answerUpload: faq.ImageUrl || faq.imageUrl || "",
                                });
                            });
                            setFaqs(transformedFaqs);
                            pagination = apiResponse.pagination || apiResponse.meta || {};
                            totalCount = Number((_g = (_f = (_e = (_d = (_c = (_b = (_a = apiResponse.totalCount) !== null && _a !== void 0 ? _a : apiResponse.total) !== null && _b !== void 0 ? _b : apiResponse.count) !== null && _c !== void 0 ? _c : apiResponse.totalRecords) !== null && _d !== void 0 ? _d : pagination.totalCount) !== null && _e !== void 0 ? _e : pagination.total) !== null && _f !== void 0 ? _f : pagination.count) !== null && _g !== void 0 ? _g : 0);
                            totalPages = Number((_j = (_h = apiResponse.totalPages) !== null && _h !== void 0 ? _h : pagination.totalPages) !== null && _j !== void 0 ? _j : 0);
                            if (totalPages > 0) {
                                setChatbotTotalPages(totalPages);
                                setChatbotTotalCount(totalCount > 0 ? totalCount : totalPages * CHATBOT_FAQ_PAGE_SIZE);
                            }
                            else if (totalCount > 0) {
                                setChatbotTotalPages(Math.max(1, Math.ceil(totalCount / CHATBOT_FAQ_PAGE_SIZE)));
                                setChatbotTotalCount(totalCount);
                            }
                            else {
                                estimatedTotalPages = transformedFaqs.length < CHATBOT_FAQ_PAGE_SIZE ? page : page + 1;
                                setChatbotTotalPages(estimatedTotalPages);
                                setChatbotTotalCount((page - 1) * CHATBOT_FAQ_PAGE_SIZE + transformedFaqs.length);
                            }
                        }
                        else {
                            console.warn("Failed to fetch chatbot FAQs:", (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.message);
                            setFaqs([]);
                        }
                        return [3, 3];
                    case 2:
                        error_4 = _l.sent();
                        console.error("Error fetching chatbot FAQs:", error_4);
                        setFaqs([]);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    var refreshFaqs = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isChatbotFaqs) return [3, 2];
                    return [4, fetchChatbotFaqs()];
                case 1:
                    _a.sent();
                    return [2];
                case 2:
                    if (!portalId) return [3, 4];
                    return [4, fetchFaqsForPortal(portalId)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (isChatbotFaqs) {
            void resolveDefaultPortalId();
            return;
        }
        if (portalIdProp != null) {
            setPortalId(portalIdProp);
            setIsLoadingFaqs(true);
            fetchFaqsForPortal(portalIdProp).finally(function () { return setIsLoadingFaqs(false); });
            return;
        }
        fetchAllFaqs();
    }, [portalIdProp]);
    useEffect(function () {
        if (!isChatbotFaqs)
            return;
        setIsLoadingFaqs(true);
        fetchChatbotFaqs(chatbotPage).finally(function () { return setIsLoadingFaqs(false); });
    }, [isChatbotFaqs, chatbotPage]);
    var handleAddFaq = function () {
        setIsAddingFaq(true);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        setExistingAnswerImagePath("");
    };
    var handleEditFaq = function (faq) {
        setEditingFaqId(faq.id);
        setQuestion(preserveBulletPoints(faq.question));
        setContent(preserveBulletPoints(faq.answer));
        setAnswerUpload(null);
        setExistingAnswerImagePath(faq.answerUpload || "");
        setImageRemovedInEdit(false);
    };
    var handleCancelEdit = function () {
        setEditingFaqId(null);
        setIsAddingFaq(false);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        setExistingAnswerImagePath("");
        setImageRemovedInEdit(false);
    };
    var handleSaveChatbotFaq = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedQuestion, trimmedAnswer, response, error_5, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    trimmedQuestion = preserveBulletPoints(question.trim());
                    trimmedAnswer = preserveBulletPoints(content.trim());
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 12, , 13]);
                    response = void 0;
                    if (!isAddingFaq) return [3, 3];
                    if (!faqPerms.canCreate) {
                        utility.alert("You don't have permission to add FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_CHATBOT_FAQ_CREATE,
                            headerType: api_service.ContentHeaders.Json,
                            payLoad: { question: trimmedQuestion, answer: trimmedAnswer },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    return [3, 6];
                case 3:
                    if (!(editingFaqId !== null)) return [3, 5];
                    if (!faqPerms.canEdit) {
                        utility.alert("You don't have permission to edit FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    return [4, api_service.put({
                            endPoint: api_urls.CUSTOMER_PORTAL_CHATBOT_FAQ_UPDATE,
                            headerType: api_service.ContentHeaders.Json,
                            payLoad: {
                                id: editingFaqId,
                                question: trimmedQuestion,
                                answer: trimmedAnswer,
                            },
                            showLoader: true,
                        })];
                case 4:
                    response = _d.sent();
                    return [3, 6];
                case 5: return [2];
                case 6:
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 10];
                    utility.alert(response.data.message ||
                        (isAddingFaq
                            ? "FAQ created successfully!"
                            : "FAQ updated successfully!"), constants.TOAST_TYPES.INFO);
                    if (!(isAddingFaq && chatbotPage !== 1)) return [3, 7];
                    setChatbotPage(1);
                    return [3, 9];
                case 7: return [4, refreshFaqs()];
                case 8:
                    _d.sent();
                    _d.label = 9;
                case 9:
                    handleCancelEdit();
                    return [3, 11];
                case 10:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to save FAQ", constants.TOAST_TYPES.ERROR);
                    _d.label = 11;
                case 11: return [3, 13];
                case 12:
                    error_5 = _d.sent();
                    console.error("Error saving chatbot FAQ:", error_5);
                    errorMessage = ((_c = (_b = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_5 === null || error_5 === void 0 ? void 0 : error_5.message) ||
                        "Failed to save FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 13];
                case 13: return [2];
            }
        });
    }); };
    var handleSaveFaq = function () { return __awaiter(void 0, void 0, void 0, function () {
        var formData, processedContent, response, error_6, errorMessage, formData, processedContent, response, error_7, errorMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!hasTextContent(question)) {
                        utility.alert("Question is required", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!hasTextContent(content)) {
                        utility.alert("Answer is required", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!isChatbotFaqs) return [3, 2];
                    return [4, handleSaveChatbotFaq()];
                case 1:
                    _g.sent();
                    return [2];
                case 2:
                    if (answerUpload && answerUpload.size > FAQ_FILE_MAX_SIZE_BYTES) {
                        utility.alert("File size exceeds 25 MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!isAddingFaq) return [3, 10];
                    if (!faqPerms.canCreate) {
                        utility.alert("You don't have permission to add FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!portalId) {
                        utility.alert("Portal ID is required. Please refresh the page.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 8, , 9]);
                    formData = new FormData();
                    formData.append("portalId", String(portalId));
                    formData.append("question", preserveBulletPoints(question.trim()));
                    processedContent = preserveBulletPoints(content.trim() || " ");
                    formData.append("answer", processedContent);
                    if (answerUpload) {
                        formData.append("answerImage", answerUpload);
                    }
                    else {
                        formData.append("answerImage", "");
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_CREATE,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true,
                        })];
                case 4:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 6];
                    utility.alert(response.data.message || "FAQ created successfully!", constants.TOAST_TYPES.INFO);
                    return [4, refreshFaqs()];
                case 5:
                    _g.sent();
                    setIsAddingFaq(false);
                    setQuestion("");
                    setContent("");
                    setAnswerUpload(null);
                    return [3, 7];
                case 6:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to create FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 7;
                case 7: return [3, 9];
                case 8:
                    error_6 = _g.sent();
                    console.error("Error creating FAQ:", error_6);
                    errorMessage = ((_c = (_b = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_6 === null || error_6 === void 0 ? void 0 : error_6.message) ||
                        "Failed to create FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 9];
                case 9: return [3, 17];
                case 10:
                    if (!(editingFaqId !== null)) return [3, 17];
                    if (!faqPerms.canEdit) {
                        utility.alert("You don't have permission to edit FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!portalId) {
                        utility.alert("Portal ID is required. Please refresh the page.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 11;
                case 11:
                    _g.trys.push([11, 16, , 17]);
                    formData = new FormData();
                    formData.append("portalId", String(portalId));
                    formData.append("question", preserveBulletPoints(question.trim()));
                    processedContent = preserveBulletPoints(content.trim());
                    formData.append("answer", processedContent);
                    formData.append("id", String(editingFaqId));
                    if (answerUpload) {
                        formData.append("answerImage", answerUpload);
                    }
                    else if (imageRemovedInEdit) {
                        formData.append("answerImage", "");
                    }
                    else if (!existingAnswerImagePath) {
                        formData.append("answerImage", "");
                    }
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_UPDATE,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true,
                        })];
                case 12:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 14];
                    utility.alert(response.data.message || "FAQ updated successfully!", constants.TOAST_TYPES.INFO);
                    return [4, refreshFaqs()];
                case 13:
                    _g.sent();
                    setEditingFaqId(null);
                    setQuestion("");
                    setContent("");
                    setAnswerUpload(null);
                    setExistingAnswerImagePath("");
                    setImageRemovedInEdit(false);
                    return [3, 15];
                case 14:
                    utility.alert(((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || "Failed to update FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 15;
                case 15: return [3, 17];
                case 16:
                    error_7 = _g.sent();
                    console.error("Error updating FAQ:", error_7);
                    errorMessage = ((_f = (_e = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_7 === null || error_7 === void 0 ? void 0 : error_7.message) ||
                        "Failed to update FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 17];
                case 17: return [2];
            }
        });
    }); };
    var handleDeleteFaq = function (id) {
        setPendingDeleteFaqId(id);
        setDeleteConfirmationOpen(true);
    };
    var handleConfirmDeleteFaq = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_8, errorMessage, payload, response, error_9, errorMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!faqPerms.canDelete) {
                        utility.alert("You don't have permission to delete FAQs", constants.TOAST_TYPES.ERROR);
                        setDeleteConfirmationOpen(false);
                        setPendingDeleteFaqId(null);
                        return [2];
                    }
                    if (!isChatbotFaqs) return [3, 11];
                    if (pendingDeleteFaqId === null) {
                        setDeleteConfirmationOpen(false);
                        return [2];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 8, 9, 10]);
                    return [4, api_service.delete({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_CHATBOT_FAQ_DELETE, "/").concat(pendingDeleteFaqId),
                            showLoader: true,
                        })];
                case 2:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 6];
                    utility.alert(response.data.message || "FAQ deleted successfully!", constants.TOAST_TYPES.INFO);
                    if (!(faqs.length === 1 && chatbotPage > 1)) return [3, 3];
                    setChatbotPage(function (prev) { return prev - 1; });
                    return [3, 5];
                case 3: return [4, refreshFaqs()];
                case 4:
                    _g.sent();
                    _g.label = 5;
                case 5: return [3, 7];
                case 6:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to delete FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 7;
                case 7: return [3, 10];
                case 8:
                    error_8 = _g.sent();
                    console.error("Error deleting chatbot FAQ:", error_8);
                    errorMessage = ((_c = (_b = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_8 === null || error_8 === void 0 ? void 0 : error_8.message) ||
                        "Failed to delete FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 10];
                case 9:
                    setDeleteConfirmationOpen(false);
                    setPendingDeleteFaqId(null);
                    return [7];
                case 10: return [2];
                case 11:
                    if (pendingDeleteFaqId === null || !portalId) {
                        setDeleteConfirmationOpen(false);
                        setPendingDeleteFaqId(null);
                        return [2];
                    }
                    _g.label = 12;
                case 12:
                    _g.trys.push([12, 17, 18, 19]);
                    payload = {
                        id: pendingDeleteFaqId,
                        portalId: Number(portalId),
                    };
                    return [4, api_service.delete({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_DELETE,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 13:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 15];
                    utility.alert(response.data.message || "FAQ deleted successfully!", constants.TOAST_TYPES.INFO);
                    return [4, refreshFaqs()];
                case 14:
                    _g.sent();
                    return [3, 16];
                case 15:
                    utility.alert(((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || "Failed to delete FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 16;
                case 16: return [3, 19];
                case 17:
                    error_9 = _g.sent();
                    console.error("Error deleting FAQ:", error_9);
                    errorMessage = ((_f = (_e = error_9 === null || error_9 === void 0 ? void 0 : error_9.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_9 === null || error_9 === void 0 ? void 0 : error_9.message) ||
                        "Failed to delete FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 19];
                case 18:
                    setDeleteConfirmationOpen(false);
                    setPendingDeleteFaqId(null);
                    return [7];
                case 19: return [2];
            }
        });
    }); };
    var handleCancelDeleteFaq = function () {
        setDeleteConfirmationOpen(false);
        setPendingDeleteFaqId(null);
    };
    var handleAnswerUpload = function (event) {
        var _a, _b, _c;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        var input = event.target;
        if (!file)
            return;
        if (file.size > FAQ_FILE_MAX_SIZE_BYTES) {
            utility.alert("File size exceeds 25 MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
            input.value = "";
            return;
        }
        var allowedTypes = FAQ_FILE_ALLOWED_TYPES;
        var fileType = (_b = file.type) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        var fileExtension = (_c = file.name.split(".").pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        var isAllowedType = allowedTypes.includes(fileType) ||
            ["jpg", "jpeg", "png", "gif", "webp", "pdf"].includes(fileExtension || "");
        if (!isAllowedType) {
            utility.alert("Invalid file type. Allowed: JPG, PNG, GIF, WebP, or PDF.", constants.TOAST_TYPES.ERROR);
            input.value = "";
            return;
        }
        setAnswerUpload(file);
        setExistingAnswerImagePath("");
        if (editingFaqId !== null) {
            setImageRemovedInEdit(true);
        }
        input.value = "";
    };
    var faqContent = (React.createElement(Stack, { sx: { gap: 3 } },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Typography, { variant: "body1", fontWeight: 600 }, embedded ? heading : ""),
            faqPerms.canView && faqPerms.canCreate && (React.createElement(Button, { variant: "contained", startIcon: React.createElement(AddIcon, null), sx: { textTransform: "none" }, onClick: handleAddFaq }, "Add FAQ"))),
        isAddingFaq && (React.createElement(Stack, { sx: {
                border: "1px dashed ".concat(colors.greyShades[18]),
                borderRadius: 2,
                p: 3,
                gap: 2,
                bgcolor: "rgba(0,0,0,0.01)",
            } },
            React.createElement(Stack, { spacing: 0.5 },
                React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                    "Question ",
                    React.createElement("span", { style: { color: "red" } }, "*")),
                React.createElement(RichTextEditor, { value: question, maxLength: 200, onChange: function (html) {
                        var plainTextLength = getPlainTextLength(html);
                        if (plainTextLength <= 200) {
                            setQuestion(html);
                        }
                    } }),
                React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "right" },
                    getPlainTextLength(question),
                    " / 200 characters")),
            React.createElement(Stack, { spacing: 0.5 },
                React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                    "Answer ",
                    React.createElement("span", { style: { color: "red" } }, "*")),
                React.createElement(RichTextEditor, { value: content, maxLength: 2000, onChange: function (html) {
                        var plainTextLength = getPlainTextLength(html);
                        if (plainTextLength <= 2000) {
                            setContent(html);
                        }
                    } }),
                React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "right" },
                    getPlainTextLength(content),
                    " / 2000 characters")),
            !isChatbotFaqs && (React.createElement(Stack, { spacing: 0.5 },
                React.createElement(Typography, { fontSize: 14, fontWeight: 500 }, "Answer File (Optional)"),
                React.createElement(Typography, { fontSize: 12, color: "text.secondary" }, "Allowed: JPG, PNG, GIF, WebP, or PDF (Max 25 MB)"),
                React.createElement(Button, { component: "label", variant: "outlined", sx: { textTransform: "none", alignSelf: "flex-start" } },
                    "Upload File",
                    React.createElement("input", { type: "file", hidden: true, onChange: handleAnswerUpload, accept: ".jpg,.jpeg,.png,.gif,.webp,.pdf" })),
                answerUpload && (React.createElement(Typography, { fontSize: 12, color: "success.main" },
                    "\u2713 ",
                    answerUpload.name)))),
            React.createElement(Stack, { direction: "row", spacing: 2 },
                React.createElement(Button, { variant: "outlined", onClick: handleCancelEdit, sx: {
                        textTransform: "none",
                        borderColor: colors.greyShades[18],
                        color: "text.primary",
                    } }, "Cancel"),
                React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleSaveFaq, disabled: !faqPerms.canCreate }, "Save FAQ")))),
        isLoadingFaqs ? (React.createElement(Typography, { variant: "body2", sx: { textAlign: "center", py: 6, color: "text.secondary" } }, "Loading FAQs...")) : faqs.length === 0 && !isAddingFaq ? (React.createElement(Stack, { sx: {
                textAlign: "center",
                py: 6,
                bgcolor: "rgba(0,0,0,0.01)",
                borderRadius: 2,
                border: "1px dashed ".concat(colors.greyShades[18]),
            } },
            React.createElement(Typography, { variant: "body2", sx: { color: "text.secondary", mb: 2 } }, "No FAQs found"),
            faqPerms.canView && faqPerms.canCreate && (React.createElement(Typography, { variant: "caption", color: "text.secondary" }, "Click \"Add FAQ\" button above to create your first FAQ")))) : null,
        faqs.map(function (faq) {
            return editingFaqId === faq.id ? (React.createElement(Stack, { key: faq.id, sx: {
                    border: "1px dashed ".concat(colors.greyShades[18]),
                    borderRadius: 2,
                    p: 2,
                    gap: 2,
                } },
                React.createElement(Stack, { spacing: 0.5 },
                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                        "Question ",
                        React.createElement("span", { style: { color: "red" } }, "*")),
                    React.createElement(RichTextEditor, { value: question, maxLength: 200, onChange: function (html) {
                            var plainTextLength = getPlainTextLength(html);
                            if (plainTextLength <= 200) {
                                setQuestion(html);
                            }
                        } }),
                    React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "right" },
                        getPlainTextLength(question),
                        " / 200 characters")),
                React.createElement(Stack, { spacing: 0.5 },
                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                        "Answer ",
                        React.createElement("span", { style: { color: "red" } }, "*")),
                    React.createElement(RichTextEditor, { value: content, maxLength: 2000, onChange: function (html) {
                            var plainTextLength = getPlainTextLength(html);
                            if (plainTextLength <= 2000) {
                                setContent(html);
                            }
                        } }),
                    React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "right" },
                        getPlainTextLength(content),
                        " / 2000 characters")),
                !isChatbotFaqs && (React.createElement(Stack, { spacing: 0.5 },
                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 }, "Answer File (Optional)"),
                    React.createElement(Typography, { fontSize: 12, color: "text.secondary" }, "Allowed: JPG, PNG, GIF, WebP, or PDF (Max 25 MB)"),
                    React.createElement(Button, { component: "label", variant: "outlined", sx: { textTransform: "none" } },
                        "Upload File",
                        React.createElement("input", { type: "file", hidden: true, onChange: handleAnswerUpload, accept: ".jpg,.jpeg,.png,.gif,.webp,.pdf" })),
                    answerUpload && (React.createElement(Typography, { fontSize: 12, color: "success.main" },
                        "\u2713 ",
                        answerUpload.name)),
                    !imageRemovedInEdit && existingAnswerImagePath && (React.createElement(Typography, { fontSize: 12, color: "info.main" },
                        "\uD83D\uDCCE Current file: ",
                        existingAnswerImagePath)))),
                React.createElement(Stack, { direction: "row", spacing: 2 },
                    React.createElement(Button, { variant: "outlined", onClick: handleCancelEdit, sx: {
                            textTransform: "none",
                            borderColor: colors.greyShades[18],
                            color: "text.primary",
                        } }, "Cancel"),
                    React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleSaveFaq, disabled: !faqPerms.canEdit }, "Update FAQ")))) : (React.createElement(Accordion, { key: faq.id, sx: {
                    bgcolor: colors.fullWhite,
                    borderRadius: "8px !important",
                    boxShadow: "none",
                    border: "1px dashed ".concat(colors.greyShades[18]),
                    "&:before": { display: "none" },
                    "&.Mui-expanded": { margin: 0 },
                } },
                React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: {
                        "& .MuiAccordionSummary-content": {
                            margin: 0,
                            justifyContent: "space-between",
                            alignItems: "center",
                        },
                        "&.Mui-expanded": {
                            borderBottom: "1px solid ".concat(colors.greyShades[18]),
                        },
                    } },
                    React.createElement(Box, { sx: {
                            fontWeight: 600,
                            fontSize: 14,
                            "& p": { margin: 0 },
                            "& ol, & ul": { pl: 2 },
                        }, dangerouslySetInnerHTML: { __html: faq.question } })),
                React.createElement(AccordionDetails, { sx: { padding: "16px" } },
                    React.createElement(Stack, { spacing: 2, width: "100%" },
                        React.createElement(Box, { sx: {
                                fontSize: 14,
                                color: "text.secondary",
                                "& ol, & ul": { pl: 2 },
                            }, dangerouslySetInnerHTML: { __html: faq.answer } }),
                        faq.answerUpload && (React.createElement(Box, { sx: { mt: 1 } },
                            React.createElement("img", { src: getImageUrl(faq.answerUpload), alt: "FAQ attachment", style: {
                                    maxWidth: "200px",
                                    height: "200px",
                                    borderRadius: "8px",
                                    border: "1px solid ".concat(colors.greyShades[18]),
                                    objectFit: "contain",
                                } }))),
                        React.createElement(Stack, { direction: "row", spacing: 1, sx: { justifyContent: "flex-start" } },
                            faqPerms.canEdit && (React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(EditOutlinedIcon, null), onClick: function () { return handleEditFaq(faq); }, sx: { textTransform: "none" } }, "Edit")),
                            faqPerms.canDelete && (React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(DeleteOutlineIcon, null), onClick: function () { return handleDeleteFaq(faq.id); }, sx: {
                                    textTransform: "none",
                                    borderColor: colors.errorShades[10],
                                    color: colors.errorShades[10],
                                    "&:hover": {
                                        borderColor: colors.errorShades[10],
                                        color: colors.errorShades[10],
                                    },
                                } }, "Delete")))))));
        }),
        isChatbotFaqs && !isLoadingFaqs && faqs.length > 0 && chatbotTotalPages > 1 && (React.createElement(CommonTablePagination, { tableData: faqs, currentPage: chatbotPage, perPageCount: CHATBOT_FAQ_PAGE_SIZE, setCurrentPage: setChatbotPage, setPerPageCount: function () { }, totalNumberOfRecords: chatbotTotalCount, hideRowsPerPage: true }))));
    var deletePopup = (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Delete FAQ", message: "Are you sure you want to delete this FAQ?", acceptBtnText: "Yes", denyBtnText: "No", open: deleteConfirmationOpen, acceptCallBack: handleConfirmDeleteFaq, denyCallBack: handleCancelDeleteFaq, cancelCallBack: handleCancelDeleteFaq, swapButtonOrder: true }));
    if (embedded) {
        return (React.createElement(React.Fragment, null,
            faqContent,
            deletePopup));
    }
    return (React.createElement(Box, { sx: { p: 3, bgcolor: "#f5f5f5", minHeight: "100vh" } },
        React.createElement(Stack, { mb: 4 },
            React.createElement(Typography, { variant: "h5", sx: { fontWeight: 600, mb: 1 } }, heading),
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "Manage Customer Portal AI chatbot knowledge by maintaining FAQs, updating existing content, or creating new training data.")),
        React.createElement(Stack, { sx: {
                bgcolor: "white",
                borderRadius: 2,
                p: 3,
            } }, faqContent),
        deletePopup));
};
export default CustomerPortalFaqManagement;
